import React, { useContext, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import MicrophoneControl from "./VoitekMute";
import customerChatUseStore from "modules/customer_chats/store";
import VoitekCall from "assets/svgs/voitek_call";
import CallCut from "assets/svgs/call_cut.js";
import { toast } from "react-toastify";
import { currentUser, ROLES_NAME, TOAST_MESSAGE_CSS } from "modules/utilities/utility";
import useStatsStore from "modules/engagement_report/engagement_stats/store";
import { ActiveEngagement } from "./ShowEngagement";
import secureLocalStorage from "react-secure-storage";
import { Tooltip } from "antd";
import { useCallingStore } from 'modules/navbar/top/store/store';
import { useBookingData } from "modules/nextcall/store";

function VoitekkIntegration(props) {
    const {voitekkCalling, updateCallingStatus } = useCallingStore();
    const [stream, setStream] = useState(null);
    const [isMuted, setIsMuted] = useState(false);
    const userId = secureLocalStorage.getItem('id');
    const currentUrl = window.location.href.split("/");
    const { fetchCall } = customerChatUseStore();
    const prevCustomerIdRef = useRef(null);
    const {nextEngagementData} = props;

    const {activeEngagement} = useContext(ActiveEngagement);
    const callEngagementData = currentUrl.includes('next-call')? nextEngagementData: activeEngagement;
    console.log('comment', callEngagementData, 'and', activeEngagement);
    const callObject = {
        phone_number: props?.phone,
        case_id: props?.caseId,
        note: {},
        userId,
        isVoitekk: true,
        engagement_id: callEngagementData
    }
    const { fetchUserData, users } = useStatsStore();
    useEffect(() => {
      fetchUserData();
    }, []);
    const currentVoitekUser = users?.filter((user) => {
      return user?.user_id === userId;
    });

    const voitekUser = secureLocalStorage.getItem('voitekk_id');
    const voitekUserData = (voitekUser!==null && voitekUser!=="null")? voitekUser :false;
    let agentId = currentVoitekUser[0]?.user?.voitekk_id||voitekUserData|| props.userId || 5;

    useEffect(() => {
        if ( props?.caseId && nextEngagementData && currentUrl.includes("next-call") && (currentVoitekUser[0]?.user?.voitekk_id||voitekUserData) && [ROLES_NAME.LEAD_AGENT].includes(currentUser)) {
          if (nextEngagementData.case_id !== secureLocalStorage.getItem("previousCustomer") && nextEngagementData.case_id ===  props?.caseId) {
            setTimeout(() => {
                handleCallStart();
            }, 3000);
            prevCustomerIdRef.current =  props?.caseId;
            secureLocalStorage.setItem("previousCustomer", prevCustomerIdRef.current);
          }
        }
      }, [props?.caseId]);

    const handleCallStart = () => {
        if(props.callDndFlag){
            toast('Customer is in DND mode, Please do not call', TOAST_MESSAGE_CSS);
            return;
        }
        updateCallingStatus('voitekkCalling', true);
        turnOnMic();
        let agentUserName = props.name || "Test";
        console.log(`Calling to Voitekk registerSip with user name: ${agentUserName} and user Id: ${agentId} and engagementId`, callEngagementData);
        registerSip(agentUserName);
        let phoneNumber = props.phone;
        if (phoneNumber.startsWith("+91")) {
            phoneNumber = phoneNumber.slice(3);
        }
        const timeoutDuration = 2000; // Adjust the timeout duration as needed
        setTimeout(() => {
            if(callEngagementData){
                console.log('Calling with engagementid', callEngagementData, "And userId", userId );
                WebToSipCall(agentUserName, agentId, phoneNumber, callEngagementData, userId);
            } else{
                console.log('Agent is not able to call with', phoneNumber, "And userId", userId);
                WebToSipCall(agentUserName, agentId, phoneNumber, callEngagementData, userId);
            }
            console.log("WebToSipCall called.");
        }, timeoutDuration);
        fetchCall(callObject)
    };

    const handleCallEnd = () => {
        call.terminate();
        updateCallingStatus('voitekkCalling', false);
        isMuted && turnOffMic();
        navigator.mediaDevices
            .getUserMedia({ audio: true })
            .then((mediaStream) => {
                const tracks = mediaStream.getTracks();
                tracks.forEach((track) => {
                    track.stop();
                })
            })
            .catch((err) => {
                console.error("Error accessing microphone:", err);
            });
    };

    const turnOnMic = () => {
        navigator.mediaDevices
            .getUserMedia({ audio: true })
            .then((mediaStream) => {
                setStream(mediaStream);
                const audioElement = new Audio();
                // Set the audio stream as the source of the audio element
                audioElement.srcObject = mediaStream;
                setIsMuted(!isMuted);
                // Play the audio
                // audioElement.play().catch((err) => {
                //   console.error("Error playing audio:", err);

                // });
            })
            .catch((err) => {
                console.error("Error accessing microphone:", err);
            });
    }


  const turnOffMic = () => {
    setStream(null);
    const tracks = stream.getTracks(); // Get all tracks from the stream
    tracks.forEach((track) => {
      track.stop();
    });
    setIsMuted(!isMuted);
  };

    return (
        <div className={`text-center ${props.callDndFlag ? 'disabled-action' : 'cursor-pointer'}`}>
            <Helmet>
                <script src="https://172.16.1.9/voitekk/assets/js/jssip-0.7.10.min.js" type="text/javascript"></script>
                <script src="https://172.16.1.9/voitekk/assets/js/alertify.min.js" type="text/javascript"></script>
                <script src="https://172.16.1.9/voitekk/assets/js/jquery-1.8.3.min.js" type="text/javascript"></script>
                <script src="https://172.16.1.9/voitekk/assets/js/jquery.js" type="text/javascript"></script>
                <script src="https://172.16.1.9/voitekk/assets/js/webSipConnection.js"></script>
            </Helmet>
            <Tooltip placement="bottom" title='Voitekk'>
            <div className="d-flex justify-content-center gap-2 text-wrap">
                {!voitekkCalling ? <span
                    className={`button callStart ${voitekkCalling ? "disabled" : ""}`}
                    name="callStartButton"
                    type="button"
                    value="call"
                    onClick={handleCallStart}
                    disabled={voitekkCalling}
                >
                    <VoitekCall />
                </span> : <>
                    <span
                        className={`button callEnd ${!voitekkCalling ? "disabled" : ""} pl-small`}
                        name="callEndButton"
                        type="button"
                        value="call"
                        onClick={handleCallEnd}
                        disabled={!voitekkCalling}
                    >
                        <CallCut />
                    </span>
                    <MicrophoneControl
                        turnOnMic={turnOnMic}
                        turnOffMic={turnOffMic}
                        isMuted={isMuted}
                    />
                </>

                }
            </div>
            </Tooltip>
            <video id="remoteView" autoPlay="" poster="" src="" hidden="hidden" />
        </div>
    );
}

export default VoitekkIntegration;
